import React, { useEffect, useState } from 'react';
import Table from '@/components/organisms/table';
import useTranslation from '@/providers/I18n/hooks/useTranslation';
import Button from '@/components/atoms/button';
import { dateFormat, statusColor } from '../../helper';
import Typography from '@/components/atoms/typography';
import { useLocale } from 'next-intl';

const DetailsTable = ({ orderLines, productType }: Partial<any>) => {
    const locale = useLocale()
    const [isServer, setIsServer] = useState(true)
    let showCustomerServiceLine: boolean = false;
    const handleDownload = (img: any, name: string) => {
        const type = img ? detectMimeType(img?.slice(0, 256)) : "image/png";
        const extension = type?.split('/')[1];
        const imgName = name ? `${name}.${extension}` : `asset.${extension}`;
        const a = !isServer && document.createElement("a");
        if (a) {
            a.href = `data:${type};base64,` + img;
            a.download = imgName;
            a.click();
        }
    };

    const signatures: any = {
        JVBERi0: "application/pdf",
        R0lGODdh: "image/gif",
        R0lGODlh: "image/gif",
        iVBORw0KGgo: "image/png",
        "/9j/": "image/jpg"
    };

    function detectMimeType(b64: string) {
        for (let s in signatures) {
            if (b64.indexOf(s) === 0) {
                return signatures[s];
            }
        }
    }
    const checkETALogic = (estimatedDeliveryDate: Date | null) => {
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Clear the time component for comparison
        const maxDate = new Date(today);
        maxDate.setDate(today.getDate() + 60);
        const invalidDate = new Date(1900, 0, 1, 12);

        if (!estimatedDeliveryDate) {
            return { isETAWrong: true, displayDate: '-' };
        }

        // Clear the time component of the estimated delivery date for comparison
        const cleanEstimatedDeliveryDate = new Date(estimatedDeliveryDate);
        cleanEstimatedDeliveryDate.setHours(0, 0, 0, 0);

        if (cleanEstimatedDeliveryDate > maxDate) {
            return { isETAWrong: true, displayDate: '-' };
        }
        if (cleanEstimatedDeliveryDate.getTime() === invalidDate.getTime()) {
            return { isETAWrong: true, displayDate: '-' };
        }
        if (cleanEstimatedDeliveryDate < today) {
            return { isETAWrong: true, displayDate: '-' };
        }

        const formattedDate = dateFormat(estimatedDeliveryDate.toString(), "dd/MM/yyyy");
        //console.log(formattedDate);

        return { isETAWrong: false, displayDate: formattedDate };
    };


    useEffect(() => {
        setIsServer(false)
    }, [])
    return (
        <>
            <Table className="mt-10  overflow-x-scroll">
                <Table.Container className='border-none '>
                    <Table.Head className='bg-[#FCFCFD] shadow-[0px_-1px_0px_0px_#E4E4E7_inset] shadow-none border-b border-[#CCCCCC] '>
                        <Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0 !text-start bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] !min-w-[60px] !w-[60px] capitalize !max-w-[60px]'>#No</Table.Cell>
                        {!productType && (<Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0 !text-center bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] capitalize min-w-[120px]'>Item Number</Table.Cell>)}
                        <Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0 !text-center bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] mx-1 capitalize min-w-[150px]'>Product name</Table.Cell>
                        <Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0 !text-center bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] mx-1 capitalize min-w-[100px]'>Qty Ordered</Table.Cell>
                        <Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0 !text-center bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] mx-1 capitalize min-w-[100px]'>Qty shipped</Table.Cell>
                        <Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0 !text-center bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] mx-1 capitalize min-w-[130px]'>Est. delivery date</Table.Cell>
                        <Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0 !text-center bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] mx-1 capitalize min-w-[120px]'>Status</Table.Cell>
                        <Table.Cell className='leading-[1.375rem] text-[#090909] py-[1.063rem] px-0  bg-white [&>span]:!text-[16px] border-b border-[#CCCCCC] capitalize !text-center min-w-[100px]'>Tracking</Table.Cell>
                    </Table.Head>
                    <Table.Body >
                        {orderLines?.map(({ serialNumber, itemNumber, itemName, qtyOrdered, qtyShipped, estimatedDeliveryDate, shipments, status, isBundle, isComponent, pastDate, isCritical }: any, index: number) => {
                            const isTrackingUrl = shipments && shipments[0]?.trackingUrl;
                            const isPODimage = shipments && shipments[0]?.podImageBase64String;
                            const isPODname = shipments && shipments[0]?.podImageName;
                            const orderDelivered = status?.toLowerCase() === 'delivered';
                            const disabled = !isTrackingUrl;
                            const hideButton = shipments && shipments[0]?.status?.toLowerCase() != 'delivered';
                            const { isETAWrong, displayDate } = checkETALogic(estimatedDeliveryDate);
                            const isLast = index === orderLines.length - 1;

                            return (
                                <Table.Row key={index}>
                                    <Table.Cell className=" !border-opacity-50 !border-b !border-[#CCCCCC] min-w-[60px] w-[60px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center mx-1">
                                        {serialNumber === 0 ? "-" : serialNumber}
                                    </Table.Cell>
                                    {!productType && (<Table.Cell className="!border-opacity-50 !border-b !border-[#CCCCCC] [&_p:first-of-type]:!text-[16px]  min-w-[120px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center">
                                        <div className="flex flex-col">
                                            <Typography className='!font-normal' >
                                                {itemNumber}
                                            </Typography>
                                            {isBundle && (
                                                <Typography className='uppercase !text-[10px] text-[#8b8484] !font-normal leading-[10px]'>Bundle</Typography>
                                            )}
                                            {isComponent && (
                                                <Typography className='uppercase !text-[10px] text-[#8b8484] !font-normal leading-[10px]'>Component</Typography>
                                            )}
                                        </div>
                                    </Table.Cell>)}
                                    <Table.Cell className="!border-opacity-50 !border-b !border-[#CCCCCC] min-w-[150px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center mx-1">
                                        {itemName}
                                    </Table.Cell>
                                    <Table.Cell className="!border-opacity-50 !border-b !border-[#CCCCCC] min-w-[100px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center mx-1">{isBundle ? "-" : qtyOrdered}</Table.Cell>
                                    <Table.Cell className="!border-opacity-50 !border-b !border-[#CCCCCC] min-w-[100px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center mx-1">{isBundle ? "-" : qtyShipped}</Table.Cell>
                                    <Table.Cell className="!border-opacity-50 !border-b !border-[#CCCCCC] min-w-[130px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center mx-1">
                                        {isBundle || orderDelivered ? "-" : (isETAWrong || isCritical) ? (
                                            showCustomerServiceLine = true,
                                            <span className="text-16 leading-normal font-normal text-red-600">*</span>
                                        ) : (
                                            displayDate
                                        )}
                                    </Table.Cell>
                                    <Table.Cell className=" !border-opacity-50 !border-b !border-[#CCCCCC] min-w-[120px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0 !text-center mx-1">
                                        {isBundle ? "-" : (
                                            <>
                                                <div className="flex flex-col items-center justify-center gap-1">
                                                    <Button
                                                        size="custom"
                                                        variant="secondary"
                                                        className={`w-fit !rounded-[48px] justify-center whitespace-nowrap  px-[25px] py-[2px] text-[14px] !leading-[8.98px] !font-medium text-black ${statusColor(status)} border-none !h-[30px]`}
                                                    >
                                                        {status}
                                                    </Button>
                                                    {orderDelivered && (
                                                        <Typography className='!text-[11px] leading-4 text-[#212529] text-center'>
                                                            {`on ${dateFormat(shipments[0]?.deliveryDate, "dd/MM/yyyy")}`}
                                                        </Typography>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </Table.Cell>
                                    <Table.Cell className=' !border-opacity-50 !border-b !border-[#CCCCCC] min-w-[100px] orderCellText leading-[1.375rem] text-[#090909] py-[17px] px-0  !text-center mx-1'>
                                        {(hideButton || isBundle) ? ("-") : (!isTrackingUrl && isPODimage) ? (
                                            <Button  style={{display: "flex", width:"100%", justifyContent:"center"}}  onClick={() => handleDownload(isPODimage, isPODname)} className={` !border-none flex gap-x-1 !justify-center !w-full items-center cursor-pointer bg-transparent px-2  focus-visible:!border-none focus-visible:!outline-none mb-1 !bg-[#616c5e] text-center flex-col !text-xs`}>
                                                <div className='text-[12px] leading-[16px]'>Download POD</div>
                                            </Button>
                                        ) : (
                                            <Button style={{display: "flex", width:"100%", justifyContent:"center"}} disabled={disabled} onClick={() => window.open(isTrackingUrl, '_blank')} className={`!flex !cursor-pointer !border-none gap-x-1 !justify-center !w-full items-center bg-transparent disabled:bg-transparent active:!bg-transparent  mb-1`}>
                                                <Typography className={`!text-[12px] !leading-5 !font-medium ${disabled ? "!text-[#999999]" : "!text-[#090909]"}  !underline`}>
                                                    {'View'}
                                                </Typography>
                                                <div className="">
                                                    <svg width="10" height="10" viewBox="0 0 10 10" fill={disabled ? "#999999" : "none"} xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M3.88889 1.66667V2.77778H1.11111V8.88889H7.22222V6.11111H8.33333V9.44444C8.33333 9.75128 8.08461 10 7.77778 10H0.555556C0.248733 10 0 9.75128 0 9.44444V2.22222C0 1.9154 0.248733 1.66667 0.555556 1.66667H3.88889ZM10 0V4.44444H8.88889L8.88883 1.89611L4.5595 6.22617L3.77383 5.4405L8.10272 1.11111H5.55556V0H10Z" fill={disabled ? "#999999" : "#090909"} />
                                                    </svg>
                                                </div>
                                            </Button>
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table.Container>
            </Table>
            {showCustomerServiceLine && (

                <Typography className='text-red-600 leading-[1.375rem] text-[12px] text-center md:text-right w-full'>
                    {`* Please call our Customer Service team on ${locale === "au" ? "13 14 16 " : "0800 804 222 "}for an update on the estimated delivery date`}
                </Typography>


            )}
        </>
    );
};

export default DetailsTable;
